import React, { useEffect } from 'react';
import { isEmpty } from 'lodash';

import { TextField } from '@metarouter-private/mr-mui';

import {
  useEventDebuggerTableContext,
  FILTER_KEYS,
} from 'app/event-monitoring/event-debugger/event-debugger-table/EventDebuggerTableContext';

const PLACEHOLDER = 'Search by Message ID';

export default function EventIDSearchBar(props) {
  const { cluster, updateFilter, filters } = useEventDebuggerTableContext();

  const onSearch = ({ target }) => {
    const { value } = target;

    const finalValue = isEmpty(value) ? [] : [value];

    updateFilter({ [FILTER_KEYS.EVENT_IDS]: finalValue });
  };

  useEffect(() => {
    return () => {
      updateFilter({ [FILTER_KEYS.EVENT_IDS]: [] });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TextField
      {...props}
      value={filters[FILTER_KEYS.EVENT_IDS][0] ?? ''}
      onChange={onSearch}
      disabled={!cluster}
      placeholder={PLACEHOLDER}
      key={`${cluster}-event-id`}
    />
  );
}
